import React from 'react';
import { useCustomComponent } from '@/hooks';

export interface HeaderRootProps {
  children: React.ReactNode;
}

const HeaderRootComponent: React.FC<HeaderRootProps> = ({ children }) => {
  return <div className="peptalk-chat-header">{children}</div>;
};

export const HeaderRoot: React.FC<HeaderRootProps> = (
  props: HeaderRootProps
) => {
  const Component = useCustomComponent({
    componentName: 'HeaderRoot',
    Component: HeaderRootComponent,
  });

  return <Component {...props} />;
};
